namespace GeniuzPOS.InitialData {
    export interface PsDiscCouponTypeDaysForm {
        DiscCouponType: Serenity.StringEditor;
        PromoDay: Serenity.IntegerEditor;
    }

    export class PsDiscCouponTypeDaysForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsDiscCouponTypeDays';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsDiscCouponTypeDaysForm.init)  {
                PsDiscCouponTypeDaysForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(PsDiscCouponTypeDaysForm, [
                    'DiscCouponType', w0,
                    'PromoDay', w1
                ]);
            }
        }
    }
}
